const lottie = require("lottie-web");

// Expose to the global window object
window.lottie = lottie;
